/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'
import { CustomFieldGroup } from 'models/shop'

import CustomFieldsForm from 'containers/shop/domains/form/customFieldsForm'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    productID: number,
    customFieldGroup: CustomFieldGroup,
    status: boolean,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function CustomFieldsLightbox({ productID, customFieldGroup, status, close }: Props) {
    return (
        <Lightbox
            title={'Eligibility Requirements'}
            content={<CustomFieldsForm productID={productID} customFieldGroup={customFieldGroup} close={close}/>}
            conditions={{ state: status, action: () => close() }}
            links={[]}
            actions={[
                {
                    label: 'Back',
                    color: 'flat',
                    type: 'button',
                    func: () => close()
                },
                {
                    label: 'Save',
                    color: 'primary',
                    type: 'submit',
                    form: 'customFieldsForm'
                }
            ]}
        />
    )
}
